import { createSelector, createSlice, isAnyOf, PayloadAction } from '@reduxjs/toolkit';

import { resetAppState } from 'App/redux/appSlice';
import { signedOut, switchingAccount } from 'Auth/redux/authSlice';
import { getBulletList, getNumberedList, getOutlineList } from 'Editor/redux/listStylesSlice';

const SLICE_NAME = 'EDITOR_TOOLBAR';

const initialState: Editor.Redux.ToolbarSliceState = {
  fontFamily: 'arial',
  fontSize: 12,
  color: 'rgb(0,0,0)',
  highlightColor: 'rgb(255,252,3)',
  paragraphColor: 'rgb(255,255,255)',
  selectedList: '',
};

const ToolbarSlice = createSlice({
  name: SLICE_NAME,
  initialState,
  reducers: {
    updateToolbarValues: (
      state,
      action: PayloadAction<Partial<Editor.Redux.ToolbarSliceState>>,
    ) => {
      return { ...state, ...action.payload };
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(isAnyOf(signedOut, resetAppState, switchingAccount), () => {
      return initialState;
    });
  },
});

const getSelectedList = (state: RootState) => state.editor.toolbar.selectedList;

export const selectedBulletList = createSelector(
  [getSelectedList, getBulletList],
  (selectedList, bulletLists) => {
    if (Object.keys(bulletLists).includes(selectedList)) {
      return true;
    }
    return false;
  },
);

export const selectedNumberedList = createSelector(
  [getSelectedList, getNumberedList],
  (selectedList, numberedLists) => {
    if (Object.keys(numberedLists).includes(selectedList)) {
      return true;
    }
    return false;
  },
);

export const selectedMultilevelList = createSelector(
  [getSelectedList, getOutlineList],
  (selectedList, getOutlineList) => {
    if (Object.keys(getOutlineList).includes(selectedList)) {
      return true;
    }
    return false;
  },
);

export const { updateToolbarValues } = ToolbarSlice.actions;

export default ToolbarSlice.reducer;
